import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import { Link as RouterLink } from 'react-router-dom';
import Tooltip from 'rc-tooltip';

import styles from './notificationIndexItemStyles';

import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import ProfileImage from 'buyside/components/presentation/ProfileImage/profileImage';

// import TrashIcon from 'buyside/svgs/trash.svg';

import { getIcon, getLinkUrl, getTag } from 'buyside/util/notificationHelper';

class NotificationIndexItem extends React.Component {
  constructor() {
    super();
    this.state = { loading: false };
    this.handleView = this.handleView.bind(this);
    this.handleSetViewed = this.handleSetViewed.bind(this);
    this.handleToggleHidden = this.handleToggleHidden.bind(this);
  }

  handleView() {
    if (this.state.loading) {
      return;
    } else {
      const { notification, handleUnviewNotification, handleViewNotification } = this.props;
      this.setState({ loading: true });
      const viewFunction = notification.viewed ? handleUnviewNotification : handleViewNotification;
      viewFunction(notification.id).then(
        () => this.setState({ loading: false }),
        error => this.setState({ loading: false, error: error })
      );
    }
  }

  handleSetViewed() {
    const { notification, handleViewNotification } = this.props;
    if (!notification.viewed) handleViewNotification(notification.id);
  }

  handleToggleHidden() {
    if (this.state.loading) {
      return;
    } else {
      const { notification, handleToggleHidden } = this.props;
      this.setState({ loading: true });
      handleToggleHidden(notification.id, !notification.hidden).then(
        () => this.setState({ loading: false }),
        () => this.setState({ loading: false })
      );
    }
  }

  renderHidden() {
    return (
      <div className={styles.notificationIndexItem + ` ${styles.hidden}`}>
        Change{' '}
        <RouterLink to="/settings" className={styles.link}>
          your settings
        </RouterLink>{' '}
        if you no longer want to see these types of notifications.
        <span className={styles.undo} onClick={this.handleToggleHidden}>
          Undo
        </span>
      </div>
    );
  }

  render() {
    const { loading } = this.state;
    const { notification, currentUserId } = this.props;
    const {
      description,
      createdAt,
      linkId,
      notificationClass,
      viewed,
      associatedUser,
      hidden
    } = notification;
    if (hidden) {
      return this.renderHidden();
    } else {
      let Icon = getIcon(notificationClass, linkId);
      if (associatedUser && associatedUser.profileImageUrl) {
        Icon = () => <ProfileImage noMargin size="small" source={associatedUser.profileImageUrl} />;
      }
      return (
        <div className={styles.notificationIndexItem + ` ${viewed ? styles.viewed : ''}`}>
          <div className={styles.iconArea}>
            {Icon ? (
              <Icon
                className={classnames(styles.icon, {
                  [styles.contestWinner]: notificationClass === 'contest_winner',
                  [styles.contestFinalist]: notificationClass === 'contest_finalist',
                  [styles.placedInContest]: notificationClass === 'contest_placed'
                })}
              />
            ) : (
              ''
            )}
          </div>
          <div className={styles.descriptionArea}>
            <div className={styles.description}>
              <a
                data-heap={getTag(notificationClass)}
                href={getLinkUrl(notificationClass, linkId, currentUserId)}
                target="_blank"
                onClick={this.handleSetViewed}
              >
                {description}
              </a>
            </div>
            <div className={styles.dateArea}>{moment(createdAt).format('M/DD/YYYY h:mm a')}</div>
          </div>
          <div className={styles.actionArea}>
            {/* This is broken.
            <div className={styles.buttonArea}>
              <Tooltip overlay="Hide Notification" placement="top">
                <span onClick={this.handleToggleHidden}>
                  <TrashIcon className={styles.trashIcon} />
                </span>
              </Tooltip>
            </div> */}
            <div className={styles.buttonArea}>
              <Tooltip
                overlay={`Mark as ${viewed ? 'unread' : 'read'}`}
                placement="top"
                align={{ offset: [0, 3] }}
              >
                <span
                  className={styles.circle + ` ${viewed ? styles.filled : ''}`}
                  onClick={this.handleView}
                />
              </Tooltip>
            </div>
          </div>
          {loading && (
            <div className={styles.loadingOverlay}>
              <LoadingSpinner type="secondary" size="tiny" />
            </div>
          )}
        </div>
      );
    }
  }
}

export default NotificationIndexItem;
